import { useState } from "react";
import { profile } from "../data/profile";
import "../contact-resume.css";

export function ContactSection() {
  const [status, setStatus] = useState("");
  async function copyEmail() {
    try {
      await navigator.clipboard.writeText(profile.email);
      setStatus("Email address copied to clipboard.");
    } catch {
      setStatus(
        "Couldn’t copy automatically. Select the email address to copy it, or open it in your email app."
      );
    }
  }
  return (
    <section
      id="contact"
      className="connect-section"
      aria-labelledby="contact-heading"
    >
      <div className="wrap connect-layout">
        <div>
          <p className="micro">CONTACT</p>
          <h2 id="contact-heading">Let’s talk.</h2>
          <p className="connect-description">
            For opportunities, projects, or a conversation about the work.
          </p>
        </div>
        <div className="connect-email">
          <a className="connect-email-link" href={`mailto:${profile.email}`}>
            {profile.email}
            <span aria-hidden="true">↗</span>
          </a>
          <div className="connect-email-tools">
            <span>Opens your email app</span>
            <button onClick={copyEmail}>
              {status.startsWith("Email address copied")
                ? "Copied ✓"
                : "Copy email"}
            </button>
          </div>
          <p className="connect-copy-status" role="status">
            {status}
          </p>
          <div className="connect-social">
            <a href={profile.linkedin} target="_blank" rel="noreferrer">
              LinkedIn ↗
            </a>
            <a href={profile.github} target="_blank" rel="noreferrer">
              GitHub ↗
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
export function PortfolioFooter() {
  return (
    <footer className="end-section wrap">
      <span className="footer-wordmark">
        kevin<span>lhn</span>
      </span>
      <p>© {new Date().getFullYear()} Kevin Hernandez-Nino</p>
    </footer>
  );
}
